function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40.573",
  height: "36.064"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4950",
  "data-name": "Group 4950",
  transform: "translate(-285.5 -707.693)",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_189",
  "data-name": "Path 189",
  d: "M14713.246 10012.9c-3.853 0-7.036-.518-10.064-3.056-2.868-2.406-5.441-6.464-8.6-13.56a22.039 22.039 0 00-4.778-7.113 12.958 12.958 0 00-4.8-2.952 10.28 10.28 0 00-5.287-.416l-.556-2.284a12.194 12.194 0 016.4.412 15.1 15.1 0 015.69 3.427 24.305 24.305 0 015.385 7.934c2.965 6.658 5.425 10.58 7.967 12.717 2.522 2.113 5.177 2.535 8.646 2.535z",
  transform: "translate(-14388.781 -9272.707)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  cx: "4.508",
  cy: "4.508",
  r: "4.508",
  transform: "translate(285.5 707.693)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_14",
  "data-name": "Ellipse 14",
  cx: "4.508",
  cy: "4.508",
  r: "4.508",
  transform: "translate(317.056 734.742)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_15",
  "data-name": "Ellipse 15",
  cx: "4.508",
  cy: "4.508",
  r: "4.508",
  transform: "translate(302.405 719.552)"
}))));